module.exports = __webpack_public_path__ + "static/media/add-circle.39ec8f02.svg";